import axios from 'axios'
import store from '@/store'
import router from '@/router'
export const baseURL = 'https://api.truelife.org/api/v1'
export function apiClient(options = {}) {
  let user
  if (store.state.user.isLoggedIn) {
    user = store.state.user.jwt
  }
  return axios.create({
    baseURL,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options,
      Authorization: `Bearer ${user}`
    }
  })
}

export async function handleResp(action) {
  try {
    const dataRet = await action
    return dataRet.data
  } catch (ex) {
    if (ex.response.status === 401) {
      router.push('/login')
    }
    throw ex
  }
}
